export const SET_COLORS = "SET_COLORS";

export const setColors = (colors) => ({
  type: SET_COLORS,
  payload: colors,
});
